import React, { Component } from 'react';
import { Button, Card, Col, DatePicker, Form, Input, InputNumber, message, Radio, Row } from 'antd';
import moment from 'moment';
import { queryMaterialDocumentListBR } from '@api/administrative/material';
import { connect } from 'react-redux';
import { BackBtn } from '@comm/BackBtn';
import ModalFileList from './ModalFileList';

const FormItem = Form.Item;

class BaseForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: 0,
      selectedRowKeys: [],
      documentListBR: [],
      documentInfo: {},
      fileVisible: false,
    };
  }

  componentDidMount() {
    const { data } = this.props;
    data &&
      data.document &&
      data.document.name &&
      (this.condition = { condition: data.document.name });
    this.getMaterialDocumentListBR();
    this.setState({
      type: +data.type || 0,
      selectedRowKeys: [data.document ? data.document.uuid : ''],
      documentInfo: data.document,
    });
  }

  componentWillReceiveProps(nextProps) {
    const { data } = nextProps;
    if (data && data.uuid !== this.props.data.uuid) {
      data &&
        data.document &&
        data.document.name &&
        (this.condition = { condition: data.document.name });

      this.setState({
        type: data.type,
        selectedRowKeys: [data.document ? data.document.uuid : ''],
        documentInfo: data.document,
      });
    }
  }

  /* ------------------------------------------资料弹窗----------------------------------------------------*/
  // 弹窗开关
  handleFileVisible = flag => {
    this.setState({
      fileVisible: !!flag,
    });
  };

  // 分页跳转
  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.getMaterialDocumentListBR();
  };

  handleSearch = condition => {
    this.condition = { condition };
    this.pagination = {
      limit: 10,
      start: 1,
    };
    this.current = 1;
    this.getMaterialDocumentListBR();
  };

  // 选中
  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.setState({
      selectedRowKeys,
      documentInfo: selectedRows[0],
    });
  };

  // 获取资料列表
  getMaterialDocumentListBR = () => {
    const params = {
      ...this.pagination,
      ...this.condition,
    };
    this.setState({
      isLoading: true,
    });
    queryMaterialDocumentListBR(params).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          documentListBR: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 10,
              current: this.current,
            },
          },
          isLoading: false,
        });
      } else {
        message.error(res.message);
      }
    });
  };

  // 设置资料详情
  documentChange = e => {
    const { documentListBR } = this.state;
    const documentInfo = documentListBR.filter(item => item.uuid === e);
    this.setState({
      documentInfo: documentInfo[0],
    });
    return e;
  };

  /* ------------------------------------------资料弹窗结束-------------------------------------------------*/

  // 详情
  submit = e => {
    const { data } = this.props;
    const { selectedRowKeys } = this.state;
    if (e) {
      e.preventDefault();
    }
    this.props.form.validateFields(err => {
      if (!err) {
        const params = this.props.form.getFieldsValue();
        data.uuid && (params.uuid = data.uuid);
        params.expectReturnDate &&
          (params.expectReturnDate = params.expectReturnDate.format('YYYY-MM-DD'));
        params.documentUuid = selectedRowKeys[0];
        this.props.handSubmit(params);
      }
    });
  };

  // 借用资料类型
  handleTypeChange = e => {
    this.setState({
      type: e.target.value,
    });
  };

  render() {
    const { data, accountInfo, isSubmitting } = this.props;
    const { type, isLoading, documentListBR, documentInfo, fileVisible, selectedRowKeys } =
      this.state;
    const { getFieldDecorator } = this.props.form;
    const parentProps = {
      isLoading,
      selectedRowKeys,
      dataSource: documentListBR,
      onChange: this.handleTableChange,
      handleSearch: this.handleSearch,
      onSelectChange: this.onSelectChange,
    };
    const formItemLayout2 = {
      labelCol: { span: 4 },
      wrapperCol: { span: 8 },
    };
    return (
      <Form onSubmit={this.submit}>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
          <Button
            icon="upload"
            type="primary"
            style={{ marginRight: 10 }}
            onClick={this.submit}
            loading={isSubmitting}
          >
            发起申请
          </Button>
          {data.uuid ? (
            <Button icon="delete" style={{ marginRight: 10 }} onClick={this.props.handleDelete}>
              删除
            </Button>
          ) : null}
        </div>
        <Card>
          <Row>
            <Col span={12}>
              <FormItem label="借用资料" {...formItemLayout2}>
                <a onClick={() => this.handleFileVisible(true)}>资料列表</a>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="借用类型" {...formItemLayout2}>
                {getFieldDecorator('type', {
                  rules: [{ required: true, message: '请选择借用类型' }],
                  initialValue: +data.type || 0,
                })(
                  <Radio.Group onChange={this.handleTypeChange}>
                    <Radio value={0}>纸质原件</Radio>
                    <Radio value={1}>电子版</Radio>
                  </Radio.Group>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={12}>
              {type === 0 ? (
                <FormItem label="约定归还" {...formItemLayout2}>
                  {getFieldDecorator('expectReturnDate', {
                    rules: [{ required: true, message: '请选择约定归还日期' }],
                    initialValue: moment(data.expectReturnDate) || null,
                  })(<DatePicker style={{ width: '100%' }} />)}
                </FormItem>
              ) : (
                <FormItem label="资料水印" {...formItemLayout2}>
                  {getFieldDecorator('waterMark', {
                    rules: [{ required: true, message: '请填写资料水印' }],
                    initialValue: data.waterMark || null,
                  })(<Input />)}
                </FormItem>
              )}
            </Col>
            <Col span={12}>
              {type === 0 ? (
                <FormItem label="借用数量" {...formItemLayout2}>
                  {getFieldDecorator('number', {
                    rules: [{ required: true, message: '请填写借用数量' }],
                    initialValue: data.number || null,
                  })(
                    <InputNumber
                      min={1}
                      style={{ width: '100%' }}
                      max={documentInfo ? documentInfo.number : 0}
                    />,
                  )}
                </FormItem>
              ) : null}
            </Col>
          </Row>

          <Row>
            <FormItem label="申请说明" labelCol={{ span: 2 }} wrapperCol={{ span: 16 }}>
              {getFieldDecorator('reason', {
                rules: [{ required: true, message: '请填写申请说明' }],
                initialValue: data.reason || null,
              })(
                <Input.TextArea
                  placeholder="申请说明"
                  type="textarea"
                  autosize={{ minRows: 3, maxRows: 9 }}
                  maxLength={1000}
                />,
              )}
              <span style={{ fontSize: '12px', color: '#999' }}>*最多可输入1000字</span>
            </FormItem>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="申请人员" {...formItemLayout2}>
                <span>{data.createUserName || accountInfo.userName}</span>
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="申请时间" {...formItemLayout2}>
                <span>{moment(data.createTime || Date.now()).format('YYYY-MM-DD')}</span>
              </FormItem>
            </Col>
          </Row>
        </Card>
        {fileVisible ? (
          <ModalFileList
            {...parentProps}
            visible={fileVisible}
            condition={this.condition ? this.condition.condition : ''}
            handleCancel={() => this.handleFileVisible(false)}
          />
        ) : null}
      </Form>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(BaseForm));



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/FormBase.js